import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CheckImporterCallback,
  CheckImporterResult,
} from '../../../../models/check-importer/check-importer.types';
import { RequestApprovalTypeDetailsStore } from '../../../store/approval-type-details-store';
import { MCApprovalTypeId } from '@maslul/common-services';
import { CheckImporterCommunicationService } from '../communication/check-importer';

/**
 * סרוויס מרכזי לבדיקת יבואן לפי סוג אישור
 */
@Injectable({
  providedIn: 'root',
})
export class CheckImporterService {
  private requestApprovalTypeDetailsStore = inject(
    RequestApprovalTypeDetailsStore,
  );
  private checkImporterCommunicationService = inject(
    CheckImporterCommunicationService,
  );

  checkImporterByApprovalType(
    args: any,
  ): Observable<CheckImporterResult> | null {
    const approvalType =
      this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;

    const checkImporterCallbacks: CheckImporterCallback[] = [
      {
        approvalType:
          MCApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_PRIVATE,
        callback: () =>
          this.checkImporterCommunicationService.checkImporter(args),
      },
    ];

    const callback = checkImporterCallbacks.find(
      (cb) => cb.approvalType.toString() === approvalType,
    );

    if (callback) {
      return callback.callback();
    }

    return null;
  }
}
